<template>
  <el-select v-model="customer_id" filterable remote clearable :remote-method="searchCustomer" class="form-control" placeholder="Selectionnez un client / prospect">
    <customer v-for="customer in customers" :key="customer.id" :item="customer" present="option"></customer>
  </el-select>
</template>

<script>
  import Customer from '../../Entities/Customer.vue'

  export default {
    components: {Customer},
    name: 'customer-select',
    props: ['id'],
    data () {
      return {
        customer_id: this.id,
        customers: []
      }
    },
    watch: {
      customer_id (value) {
        if (value === '') {
          value = null
        }

        this.$emit('change', value)
      },
      id () {
        this.loadSelectCustomer()
      }
    },
    methods: {
      searchCustomer (query) {
        let self = this

        if (query.length > 2) {
          this.$nexus.get('crm2', 'customers/search', {params: {query}}).then(response => {
            self.customers = response.data.data
          })
        }
      },
      loadSelectCustomer () {
        let self = this
        this.$nexus.get('crm2', 'customers/' + this.customer_id).then(response => {
          self.customers = [response.data.data]
        })
      }
    },
    created () {
      this.loadSelectCustomer()
    }
  }
</script>



// WEBPACK FOOTER //
// CustomerSelect.vue?783db39a